import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import CalendarSearch from "../../../Layout/Master/MasterUtils/Components/CalendarSearch/CalendarComp";
import { availableFilters } from "./AppCustomTableUtils";

const CustomDataTable = (props) => {
  
  const rowsPerPageOptions = [5, 10, 20, 50]; 
  const defaultRowsPerPage = 10;
  const [filter, setFilter] = useState(false); 
  const access_level_id = sessionStorage.getItem("access_level_id");
  const lgbId = sessionStorage.getItem("lgbId");
  const {
  columns,
  data,
  isApiLoading,
  selectedItems,
  onSelectionChange,
  filterMethodsConfig,
  dataKey,
  bodyMethods,
  className,
  areaId,
  page = 0,
  pageSize = 10,
  onPageChange,
  initialFilters,
  totalCount,
} = props

  const [filters, setFilters] = useState(initialFilters);
  useEffect(() => {
    const normalizedFilters = {};
    columns.forEach(col => {
      const initVal = initialFilters?.[col.field] || null;
      normalizedFilters[col.field] = { 
        value: initVal, 
        matchMode: "contains" 
      };
    });
    setFilters(normalizedFilters);
  }, [columns, initialFilters]);

  const modifiedDateTimeNameRowFilterTemplate = (options = {}) => {
    return <CalendarSearch options={options} setFilter={setFilter} />;
  };

  const handlePageChange = (e) => {
    onPageChange(e.page + 1, e.rows);
  };
  let filterMethods = {};
  if(filterMethodsConfig){
    Object.keys(filterMethodsConfig).forEach((key) => {
      if (availableFilters.hasOwnProperty(filterMethodsConfig[key])) {
        filterMethods[key] = availableFilters[filterMethodsConfig[key]](
          props.data,
          key
        );
      }
    });
  }
    const handleFilterOnEnter = (e, primeReactFilterEvent) => {
    if (e.key === "Enter" && e.target.value.trim().length >= 2) {
      handleFilter(primeReactFilterEvent);
    }
  };
  const handleFilter = (e) => {
    const primeFilters = e.filters;
    const formattedFilters = {};
    setFilters(primeFilters);
    Object.keys(primeFilters).forEach((key) => {
      const value = primeFilters[key]?.value;
      if (value !== undefined && value !== null && value !== "") {
        formattedFilters[key] = value;
      }
    });
    props.onFilterChange && props.onFilterChange(formattedFilters);
  };
  return (
    <>
      <DataTable
        lazy
        data-testid="custom-data-table"
        className={className}
        resizableColumns
        selectionMode={"checkbox"}
        value={data}
        size="small"
        filterDisplay="row"
        loading={isApiLoading}
        dataKey={dataKey}
        emptyMessage="No data found."
        selection={selectedItems}
        onSelectionChange={onSelectionChange}
        scrollable
        scrollHeight="510px"
        paginator
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
        rows={pageSize}
        first={(page - 1) * pageSize}
        totalRecords={totalCount}
        rowsPerPageOptions={rowsPerPageOptions} 
        paginatorLeft={<div style={{ textAlign: "left", width: "100%" }} />}
        paginatorRight={null}
        onPage={handlePageChange}
        filters={filters}
        onFilter={(e) => {
          const activeElement = document.activeElement;
          activeElement?.addEventListener("keydown", (ev) => handleFilterOnEnter(ev, e), { once: true });
        }}
      >
        {columns.map((column) => {
          if (column.header === "Subcenter" && (Number(areaId) === 1 || (Number(access_level_id) === 5 && Number(lgbId) ===  5))) {
            return null;
          }else if (column.header === "Taluka" && (Number(access_level_id) === 5 && Number(lgbId) ===  5)){
            return null
          } else if (column.header === "Village" && (Number(areaId) === 1 || (Number(access_level_id) === 5 && Number(lgbId) ===  5))){
            return null
          }
          return (
            <Column
            key={column.header}
            selectionMode={column.field === "select" ? "multiple" : null}
            header={column.header}
            headerStyle={column.headerStyle}
            field={column.field}
            bodyStyle={column.bodyStyle}
            filter={column.filter !== undefined ? column.filter : filter}
            showFilterMenu={column.showFilterMenu}
            filterElement={column.isCalendar ? modifiedDateTimeNameRowFilterTemplate : filterMethods[column.field]}
            dataType={column.isCalendar ? "date" : undefined}
            frozen={column.frozen}
            alignFrozen={column.alignFrozen}
            filterPlaceholder={column.filterPlaceholder || "Search"}
            body={bodyMethods[column.field]}
          />
          ) 
      })}
      </DataTable>
    </>
  );
};

export default CustomDataTable;
